import script from "./localeData.vue?vue&type=script&lang=js"
export * from "./localeData.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__